import { Component } from "@angular/core";

@Component({
    selector: "app-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.scss"]
})
export class AppComponent {
    public bg1tireImageUrl: string = "assets/img/bg-1.png";
    public bg2tireImageUrl: string = "assets/img/bg-2.png";
}
